import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=5cf4e798&scoped=true&"
import script from "./FileField.vue?vue&type=script&lang=js&"
export * from "./FileField.vue?vue&type=script&lang=js&"
import style0 from "./FileField.vue?vue&type=style&index=0&id=5cf4e798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4e798",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
